import React from 'react';

import {
  createConsoleLogger,
  ConfigCatProvider as Provider,
  PollingMode,
  LogLevel,
} from 'configcat-react';

import config from 'config';

export const ConfigCatProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}): JSX.Element => {
  const configcatLogger = createConsoleLogger(LogLevel['Off']);

  return (
    <Provider
      sdkKey={config.configCat.key}
      pollingMode={PollingMode.AutoPoll}
      options={{
        logger: configcatLogger,
        pollIntervalSeconds: 10 * 60, // 10 min
      }}
    >
      {children}
    </Provider>
  );
};
